module.exports = __webpack_public_path__ + "img/0.c71da2f7.png";